module.exports = __webpack_public_path__ + "static/img/core-list1.e1aa6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-list1.png
// module id = c205
// module chunks = 1